<script lang="ts">
	import { getGlobalSettings } from "../getGlobalSettings";
	import Link from "./Link.svelte";
	export let headline = "";
	export let description = "";
	export let login = "";
	export let tryApp = "";
	export let url = "#";

	const { WEB_URL } = getGlobalSettings();
	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="mt-16 py-16 lg:mt-28 lg:py-28">
	<div class="container">
		<div class="mx-auto flex flex-col items-center text-center lg:max-w-5xl">
			<h1 class="text-md mb-4 lg:text-2xl">{@html headline}</h1>
			<p class="text-2xs mt-4 font-bold leading-[1.3] lg:mt-6 lg:text-sm">{@html description}</p>
			<div class="mt-18 mx-auto flex flex-col items-center gap-2 lg:mb-8 lg:mt-4 lg:flex-row lg:gap-4">
				<Link variant="primary" asButton href={url}>
					{@html tryApp}
				</Link>
				<Link variant="secondary" asButton href={`${WEB_URL}/users/sign-in`}>
					{@html login}
				</Link>
			</div>
		</div>
	</div>
</section>
